import { useEffect, useCallback } from 'react';
import confetti from 'canvas-confetti';

const BRAND_COLORS = ['#00A6A0', '#FF6F61', '#A8E6CF', '#4A90E2', '#FFD700'];

function fireConfetti(type = 'signup') {
  if (type === 'birthday') {
    // Birthday: Sustained celebration with emojis and star bursts
    const duration = 4000;
    const end = Date.now() + duration;
    const colors = ['#FFD700', '#FF6F61', '#00A6A0', '#A8E6CF', '#4A90E2'];

    (function frame() {
      confetti({ particleCount: 3, angle: 60, spread: 55, origin: { x: 0, y: 0.7 }, colors });
      confetti({ particleCount: 3, angle: 120, spread: 55, origin: { x: 1, y: 0.7 }, colors });
      if (Date.now() < end) requestAnimationFrame(frame);
    })();

    // Star burst in center
    setTimeout(() => {
      confetti({
        particleCount: 80, spread: 100, startVelocity: 45,
        origin: { x: 0.5, y: 0.4 },
        colors, shapes: ['star', 'circle'],
        ticks: 200, gravity: 0.8
      });
    }, 500);
  } else if (type === 'milestone') {
    // Milestone: Quick celebration burst
    confetti({
      particleCount: 60, spread: 70, startVelocity: 30,
      origin: { x: 0.5, y: 0.5 },
      colors: BRAND_COLORS, ticks: 150
    });
  } else {
    // Signup: Full screen celebration
    const count = 200;
    const defaults = { origin: { y: 0.7 }, colors: BRAND_COLORS };

    function fire(particleRatio, opts) {
      confetti({ ...defaults, particleCount: Math.floor(count * particleRatio), ...opts });
    }

    fire(0.25, { spread: 26, startVelocity: 55 });
    fire(0.2, { spread: 60 });
    fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
    fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
    fire(0.1, { spread: 120, startVelocity: 45 });

    // Second wave
    setTimeout(() => {
      fire(0.15, { spread: 80, startVelocity: 40 });
      fire(0.1, { spread: 100, decay: 0.91 });
    }, 700);
  }
}

export function CelebrationConfetti({ show, type = 'signup', onComplete }) {
  const triggerConfetti = useCallback(() => {
    if (show) {
      fireConfetti(type);
      const timer = setTimeout(() => {
        if (onComplete) onComplete();
      }, type === 'birthday' ? 5000 : 3000);
      return () => clearTimeout(timer);
    }
  }, [show, type, onComplete]);

  useEffect(() => {
    return triggerConfetti();
  }, [triggerConfetti]);

  return null;
}

// Keep backward compat
export function WelcomeConfetti({ show, onComplete }) {
  return <CelebrationConfetti show={show} type="signup" onComplete={onComplete} />;
}

export default WelcomeConfetti;
